import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Link } from '@inertiajs/react';
import { ClipboardList, ListChecks } from 'lucide-react';
import { cn } from '@/lib/utils';
/** Abas "Formulários" / "Quizzes" (botões do topo das telas antigas). */
export function LeadsTabs({ active, urls }) {
    const items = [
        { key: 'forms', label: 'Formulários', href: urls.forms, icon: _jsx(ClipboardList, {}) },
        { key: 'leads', label: 'Quizzes', href: urls.quizzes, icon: _jsx(ListChecks, {}) },
    ];
    return (_jsx("nav", { "aria-label": "Tipo de lead", className: "inline-flex h-9 max-w-full items-center gap-0.5 self-start overflow-x-auto rounded-lg bg-muted p-[3px] text-muted-foreground", children: items.map((item) => {
            const isActive = item.key === active;
            return (_jsxs(Link, { href: item.href, "aria-current": isActive ? 'page' : undefined, className: cn('inline-flex h-full shrink-0 items-center justify-center gap-1.5 whitespace-nowrap rounded-md px-3 text-[13px] font-medium transition-all focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring [&_svg]:size-4', isActive ? 'bg-background text-foreground shadow-sm' : 'hover:text-foreground'), children: [item.icon, item.label] }, item.key));
        }) }));
}
